// extracted by mini-css-extract-plugin
export default {"newRegister":"dashboardServico_newRegister__8ylPI","containerList":"dashboardServico_containerList__5nNC-","listagem":"dashboardServico_listagem__KBJoW"};